import * as React from 'react';
import { useUserMessage_unstable } from './useUserMessage';
import { renderUserMessage_unstable } from './renderUserMessage';
import { useUserMessageStyles_unstable } from './useUserMessageStyles.styles';
import type { UserMessageProps } from './UserMessage.types';
import type { ForwardRefComponent } from '@fluentui/react-components';
import { useCustomStyleHook } from '@fluentui-copilot/react-provider';

// UserMessage component - TODO: add more docs
export const UserMessage: ForwardRefComponent<UserMessageProps> = React.forwardRef((props, ref) => {
  const state = useUserMessage_unstable(props, ref);

  useUserMessageStyles_unstable(state);
  useCustomStyleHook('useUserMessageStyles')(state);

  return renderUserMessage_unstable(state);
});

UserMessage.displayName = 'UserMessage';
